import { onActionError } from '../../core/utils/hooks'
import { nowWithTimezone } from '../../core/utils/timezones'

import {
  PURCHASE_ORDER_STATUS_IN_REVIEW,
  TASK_STATUS_IN_PROGRESS,
  TASK_STATUS_NEGOTIATING,
  TASK_STATUS_PENDING,
  TASK_STATUS_CONFIRMED
} from '../../config/const'

import { useQuery } from '@tanstack/react-query'
import {
  loadTasksForHome,
  loadPurchaseOrdersForHome
} from '../../api/vendor/home'

export const useFetchHomeTasks = () => {
  return useQuery({
    queryKey: ['home.tasks'],
    queryFn: () => loadTasksForHome(),
    onError: onActionError
  })
}

export const useFetchHomePurchaseOrders = () => {
  return useQuery({
    queryKey: ['home.purchaseOrders'],
    queryFn: () => loadPurchaseOrdersForHome(),
    onError: onActionError
  })
}

const getList = (state) => {
  if (state && state.list) {
    return state.list
  }

  return []
}

const isDeadlineSoon = (value) => {
  const now = nowWithTimezone()

  const diff = now.diff(value, 'days')

  return diff >= -2
}

export const getTasksWaitingConfirmation = (state) => {
  const all = getList(state)
  const _filter = (item) =>
    item.vendor_status === TASK_STATUS_PENDING || item.vendor_status === TASK_STATUS_NEGOTIATING

  return all.filter(_filter)
}

export const getTasksInProgress = (state) => {
  const all = getList(state)
  const _filter = (item) =>
    item.vendor_status === TASK_STATUS_IN_PROGRESS || item.vendor_status === TASK_STATUS_CONFIRMED

  return all.filter(_filter)
}

export const getTasksWithUpcomingDeadline = (state) => {
  const all = getList(state);
  const _filter = (item) =>
    isDeadlineSoon(item.deadline_at) &&
    (item.vendor_status === TASK_STATUS_IN_PROGRESS || item.vendor_status === TASK_STATUS_CONFIRMED)

  return all.filter(_filter)
}

export const getPOsInReview = (state) => {
  const all = getList(state)
  const _filter = (item) => item.status === PURCHASE_ORDER_STATUS_IN_REVIEW

  return all.filter(_filter)
}
